import { FormLayout } from "@careinfo/layout";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm, UseFormSetError } from "react-hook-form";
import { IPage } from "../../types/interface";
import { pageValidation } from "../../utils/validationSchema";
import PageForm from "./Form";

interface Props {
  handleCreate: (
    data: IPage,
    setError: UseFormSetError<IPage>
  ) => Promise<void>;
  isCreatingPage: boolean;
}

export default function CreatePage({ handleCreate, isCreatingPage }: Props) {
  const createPageMethods = useForm<IPage>({
    resolver: yupResolver(pageValidation),
  });

  return (
    <FormLayout
      isLoading={isCreatingPage}
      handleSubmit={createPageMethods.handleSubmit}
      handleFormSubmit={handleCreate}
      buttonLabel="Create"
      disabled={isCreatingPage}
      setError={createPageMethods.setError}
    >
      <FormProvider {...createPageMethods}>
        <PageForm />
      </FormProvider>
    </FormLayout>
  );
}
